// Module
var code = "<% _.each(data, function(col){ %> <td>{{ col }}</td> <% }, this); %>";
// Exports
export default code;